import { supabase } from '../supabaseClient';
import { getOrgId } from './orgStore';

/**
 * Calls the sales_by_customer_summary Postgres function.
 * Returns one row per customer with revenue, cost, profit, paid, and GP%.
 */
export const fetchSalesByCustomerSummary = async (startDate, endDate) => {
  const { data, error } = await supabase.rpc('sales_by_customer_summary', {
    p_org_id: getOrgId(),
    p_start_date: `${startDate} 00:00:00`,
    p_end_date: `${endDate} 23:59:59`,
  });
  if (error) throw error;
  return data || [];
};

/**
 * Calls the sales_by_customer_detail Postgres function.
 * Returns one row per invoice for the given customer.
 */
export const fetchSalesByCustomerDetail = async (startDate, endDate, customerId) => {
  const { data, error } = await supabase.rpc('sales_by_customer_detail', {
    p_org_id: getOrgId(),
    p_start_date: `${startDate} 00:00:00`,
    p_end_date: `${endDate} 23:59:59`,
    p_customer_id: customerId,
  });
  if (error) throw error;
  return data || [];
};

export const fetchSalesByItemSummary = async (startDate, endDate) => {
  const { data, error } = await supabase.rpc('sales_by_item_summary', {
    p_org_id: getOrgId(),
    p_start_date: `${startDate} 00:00:00`,
    p_end_date: `${endDate} 23:59:59`,
  });
  if (error) throw error;
  return data || [];
};

export const fetchSalesByItemDetail = async (startDate, endDate, itemId) => {
  const { data, error } = await supabase.rpc('sales_by_item_detail', {
    p_org_id: getOrgId(),
    p_start_date: `${startDate} 00:00:00`,
    p_end_date: `${endDate} 23:59:59`,
    p_item_id: itemId,
  });
  if (error) throw error;
  return data || [];
};

export const fetchPurchaseBySupplierSummary = async (startDate, endDate) => {
  const { data, error } = await supabase.rpc('purchase_by_supplier_summary', {
    p_org_id: getOrgId(),
    p_start_date: `${startDate} 00:00:00`,
    p_end_date: `${endDate} 23:59:59`,
  });
  if (error) throw error;
  return data || [];
};

export const fetchPurchaseBySupplierDetail = async (startDate, endDate, supplierId) => {
  const { data, error } = await supabase.rpc('purchase_by_supplier_detail', {
    p_org_id: getOrgId(),
    p_start_date: `${startDate} 00:00:00`,
    p_end_date: `${endDate} 23:59:59`,
    p_supplier_id: supplierId,
  });
  if (error) throw error;
  return data || [];
};

export const fetchStockValuation = async () => {
  const orgId = getOrgId();
  const { data, error } = await supabase
    .from('item_with_stock')
    .select('*, category:category_id(category_name)')
    .eq('org_id', orgId)
    .eq('is_service_item', false)
    .order('sales_description', { ascending: true });
  if (error) throw error;
  return (data || []).map((item) => {
    const qty = item.quantity_on_hand || 0;
    const hasStock = qty > 0;
    return {
      item_id: item.item_id,
      stock_no: item.stock_no,
      item_name: item.sales_description,
      category: item.category?.category_name || '',
      qty_on_hand: qty,
      cost_excl: item.cost_excl || 0,
      total_value: hasStock ? qty * (item.cost_excl || 0) : 0,
      selling_price_excl: item.selling_price_excl || 0,
      retail_value: hasStock ? qty * (item.selling_price_excl || 0) : 0,
    };
  });
};
